import { getJson, postJson, putJson, deleteJson } from './ServiceHelperMethods';

class WorkflowService {
    static async getWorkflows(workspaceId) {
        const qs = workspaceId ? `?workspace=${encodeURIComponent(workspaceId)}` : '';
        return getJson(`workflows${qs}`);
    }

    static async getWorkflow(id) {
        return getJson(`workflows/${id}`);
    }

    static async createWorkflow(data) {
        return postJson('workflows', data);
    }

    static async updateWorkflow(id, data) {
        return putJson(`workflows/${id}`, data);
    }

    static async deleteWorkflow(id) {
        return deleteJson(`workflows/${id}`);
    }

    static async runWorkflow(id, input = {}) {
        return postJson(`workflows/${id}/run`, input);
    }

    static async getWorkflowRuns(id) {
        return getJson(`workflows/${id}/runs`);
    }
}

export default WorkflowService;
